import { apiService } from './api.service';
import { API_ENDPOINTS } from '../config/api';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  nombre: string;
  email: string;
  password: string;
  rol: string;
  permisos?: string[];
}

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
}

export interface AuthResponse {
  token: string;
  user: {
    id: string;
    nombre: string;
    email: string;
    rol: string;
    permisos: string[];
    bodegas?: any[];
  };
}

export interface UserProfile {
  id: string;
  nombre: string;
  email: string;
  rol: string;
  permisos: string[];
  activo: boolean;
  createdAt: string;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiService.post<AuthResponse>(
      API_ENDPOINTS.LOGIN,
      credentials,
      false
    );

    if (response.token) {
      apiService.setAuthToken(response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
    }

    return response;
  }

  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await apiService.post<AuthResponse>(
      API_ENDPOINTS.REGISTER,
      data,
      false
    );

    if (response.token) {
      apiService.setAuthToken(response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
    }

    return response;
  }

  async getProfile(): Promise<UserProfile> {
    return apiService.get<UserProfile>(API_ENDPOINTS.PROFILE);
  }

  async changePassword(data: ChangePasswordData): Promise<{ message: string }> {
    return apiService.put<{ message: string }>(
      API_ENDPOINTS.CHANGE_PASSWORD,
      data
    );
  }

  logout(): void {
    apiService.removeAuthToken();
    localStorage.removeItem('user');
    localStorage.removeItem('selectedBodega');
  }

  getCurrentUser(): any {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  isAuthenticated(): boolean {
    return apiService.isAuthenticated();
  }

  hasPermission(permission: string): boolean {
    const user = this.getCurrentUser();
    return user?.permisos?.includes(permission) || false;
  }

  hasRole(role: string): boolean {
    const user = this.getCurrentUser();
    return user?.rol === role;
  }
}

export const authService = new AuthService();
